<template>
	<div class="skyRadio">
		<el-radio-group v-model="radio" @change="handleChange" :disabled="disabled && disabled()">
			<el-radio
				class="margin_right"
				v-for="(item, index) in list"
				:label="item[props.value]"
				:key="index"
				:border="border"
				:disabled="filterOptions ? item.disabled() : item[props.disabled] == 1"
				>{{ item[props.label] }}</el-radio
			>
		</el-radio-group>
	</div>
</template>
<script>
import googleads from '@/backend/services/googleAds/googleAds.js';
export default {
	name: 'skyRadio',
	props: {
		value: {
			default: null,
			required: true
		},
		options: {
			type: Array,
			default: () => []
		},
		disabled: {
			type: Function,
			default: () => {
				return false;
			}
		},
		border: {
			type: Boolean,
			default: true
		},
		props: {
			default() {
				return {
					label: 'name',
					value: 'code',
					disabled: 'status'
				};
			}
		},
		dict: {
			type: String,
			default: ''
		},
		code: {
			type: String,
			default: ''
		},
		filterOptions: {
			type: Function,
			default: null
		}
	},
	watch: {
		value: {
			handler: function(val) {
				this.radio = val;
			},
			immediate: true
		},
		dict: {
			handler: function(val) {
				if (val) {
					this.getDict(val);
				}
			},
			immediate: true
		},
		code: {
			handler: function(val) {
				if (val) {
					this.getCode(val);
				}
			},
			immediate: true
		},
		options: {
			handler(val) {
				if (val) {
					this.list = this.filterOptions ? this.filterOptions(val) : val;
				}
			},
			immediate: true,
			deep: true
		}
	},
	data() {
		return {
			radio: '',
			list: []
		};
	},
	methods: {
		handleChange(val) {
			this.$emit('change', val);
			this.$emit('input', val);
		},
		async getCode(code) {
			let res = await googleads.codeFun(code);
			this.list = this.filterOptions ? this.filterOptions(res.data) : res.data;
		},
		async getDict(dict) {
			let res = await googleads.dictFun(dict);
			this.list = res.data;
		}
	}
};
</script>
